import React from "react";

const FooterBottom = () => {
	return (
		<>
			<hr className="h-px my-6 bg-gray-300 border-none" />

			<div>
				<p className="text-center text-gray-800">
					© CloudBread - All rights reserved
				</p>
			</div>
		</>
	);
};

export default FooterBottom;
